<template>
  <div class="stripped-table-container point-detail-table">
    <b-table
      :fields="fields"
      :items="items"
      :per-page="perPage"
      :current-page="currentPage"
    />
    <table-footer
      :perPage="perPage"
      :page="currentPage"
      :pageSizes="pageSizes"
      :totalRows="items.length"
      @pageChange="(val) => (this.currentPage = val)"
      @perPageChange="(val) => (this.perPage = val)"
    />
  </div>
</template>

<script>
import TableFooter from "./tableComponents/TableFooter.vue";
import { mapGetters } from "vuex";
import { multiply100 } from '../../utils/helper';
export default {
  components: { TableFooter },
  name: "point-detail-table",
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      perPage: 5,
      currentPage: 1,
      pageSizes: [5, 10, 20],
    };
  },
  watch: {
    items() {
      this.currentPage = 1;
    }
  },
  computed: {
    ...mapGetters("portfolioManagerStore", ["isWholeStocks", "useFractions"]),
    fields() {
      const defaultFields = [
        {
          key: "ticker",
          label: "Stock",
        },
        {
          key: "weight",
          label: this.$i18n.t("portfolioManager.table.weight"),
          formatter: (value) => `${multiply100(value)} %`,
        },
      ];
      if (this.isWholeStocks) {
        const wholeStocksFields = defaultFields;
        wholeStocksFields[1] = {
          key: "amount",
          label: this.$i18n.t("portfolioManager.table.wholeStocks"),
          formatter: (value) =>
            this.useFractions ? value.toFixed(4) : Math.floor(value),
        };
        return wholeStocksFields;
      } else if (this.items[0].capital) {
        const cashFields = defaultFields;
        cashFields[1] = {
          key: "capital",
          label: this.$i18n.t("portfolioManager.table.cashRepresentation"),
          formatter: (value) => `$${value.toFixed(2)}`,
        };
        return cashFields;
      } else {
        return defaultFields;
      }
    },
  },
};
</script>

<style>
</style>